import { useMutation } from '@tanstack/react-query';
// utils
import { TSkill } from '@newo/api/gateway';
import { notifications } from '@mantine/notifications';
import { librarySkillsAPI } from '@/services/designer/library_skills/library_skills.queries';
import useLibraryStore from '@/pages/Library/Library.store';

export const useSaveSkillScriptMutation = () => {
    return useMutation({
        mutationFn: async ({ libraryId }: { libraryId: string }) => {
            const { skillScripts } = useLibraryStore.getState();
            const latestSkills =
                await librarySkillsAPI.getLibrarySkills(libraryId);

            const skillsToSave = latestSkills.reduce<TSkill[]>(
                (accumulator, skill) => {
                    const script = skillScripts[skill.id];
                    if (
                        script !== undefined &&
                        skill.prompt_script !== script
                    ) {
                        accumulator.push({
                            ...skill,
                            prompt_script: script
                        });
                    }
                    return accumulator;
                },
                []
            );

            const promises = skillsToSave.map(async ({ id, ...skillData }) => {
                return librarySkillsAPI.updateLibrarySkill(
                    libraryId,
                    id,
                    skillData
                );
            });
            return Promise.allSettled(promises);
        },
        onSuccess: () => {
            notifications.show({
                color: 'green',
                message: 'Library skills saved successfully'
            });
        }
    });
};
